module.exports = __webpack_public_path__ + "media/styles/images/png/circle-plus-gray-8156438eae9564b7cc5d7c46ffeac4db.png";